import {
    Heading,
    useTheme,
    View,
    useAuthenticator,
    Button,
    TextField,
    PasswordField,
    CheckboxField,
    Divider,
} from "@aws-amplify/ui-react"
import { Link, Typography } from "@mui/material"

import { PRIVACY_POLICY, TERMS_OF_USE } from "../router/routes"

export const authComponents = {
    Header() {
        const { tokens } = useTheme()

        return <View textAlign="center" padding={tokens.space.large} />
    },

    SignIn: {
        Header() {
            const { tokens } = useTheme()

            return (
                <Heading
                    padding={`${tokens.space.medium} 0 0 0`}
                    level={3}
                    textAlign="center"
                >
                    Sign In
                </Heading>
            )
        },
        Footer() {
            const { toResetPassword } = useAuthenticator()
            const { tokens } = useTheme()

            return (
                <View
                    textAlign="center"
                    padding={`0 0 ${tokens.space.medium} 0`}
                >
                    <Button
                        fontWeight="normal"
                        onClick={toResetPassword}
                        size="small"
                        variation="link"
                    >
                        Reset Password
                    </Button>
                </View>
            )
        },
    },

    SignUp: {
        Header() {
            const { tokens } = useTheme()

            return (
                <Heading
                    padding={`${tokens.space.medium} 0 0 0`}
                    level={3}
                    textAlign="center"
                >
                    Create a new account
                </Heading>
            )
        },
        Footer() {
            const { toSignIn } = useAuthenticator()
            const { tokens } = useTheme()

            return (
                <>
                    <View
                        paddingLeft={32}
                        paddingRight={32}
                        paddingBottom={32}
                        paddingTop={12}
                    >
                        <Typography variant="body1">
                            <Link href={PRIVACY_POLICY} target="_blank">
                                <Divider label="Privacy policy" />
                            </Link>
                        </Typography>
                    </View>

                    <View
                        textAlign="center"
                        padding={`0 0 ${tokens.space.medium} 0`}
                    >
                        <Button
                            fontWeight="normal"
                            onClick={toSignIn}
                            size="small"
                            variation="link"
                        >
                            Back to Sign In
                        </Button>
                    </View>
                </>
            )
        },
        FormFields() {
            const { validationErrors } = useAuthenticator()

            return (
                <>
                    <TextField
                        name="given_name"
                        label="First Name"
                        isRequired
                        placeholder="Enter your first name"
                        hasError={!!validationErrors.given_name}
                        errorMessage={validationErrors.given_name as string}
                    />
                    <TextField
                        name="family_name"
                        label="Surname"
                        placeholder="Enter your surname name"
                        isRequired
                        hasError={!!validationErrors.family_name}
                        errorMessage={validationErrors.family_name as string}
                    />
                    <TextField
                        name="username"
                        label="Email"
                        placeholder="Enter your email address"
                        isRequired
                        hasError={!!validationErrors.username}
                        errorMessage={validationErrors.username as string}
                    />
                    <PasswordField
                        name="password"
                        label="Password"
                        placeholder="Enter your password"
                        isRequired
                        hasError={!!validationErrors?.password}
                        errorMessage={
                            Array.isArray(validationErrors?.password)
                                ? validationErrors?.password.join(". ")
                                : validationErrors?.password
                        }
                    />
                    <PasswordField
                        name="confirm_password"
                        label="Confirm Password"
                        isRequired
                        placeholder="Please confirm your password"
                        hasError={!!validationErrors?.confirm_password}
                        errorMessage={
                            Array.isArray(validationErrors?.confirm_password)
                                ? validationErrors?.confirm_password.join(". ")
                                : validationErrors?.confirm_password
                        }
                    />
                    <CheckboxField
                        isRequired
                        name="acknowledgement"
                        value="yes"
                        textAlign="center"
                        margin="12px 0px"
                        label={
                            <Typography variant="body1">
                                I have read and accept our{" "}
                                <Link href={TERMS_OF_USE} target="_blank">
                                    Terms of Use
                                </Link>
                            </Typography>
                        }
                    />
                </>
            )
        },
    },
    ConfirmSignUp: {
        Header() {
            const { tokens } = useTheme()
            return (
                <Heading
                    padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
                    level={3}
                >
                    Confirm Email Address
                </Heading>
            )
        },
    },
    SetupTOTP: {
        Header() {
            const { tokens } = useTheme()
            return (
                <Heading
                    padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
                    level={3}
                >
                    Enter Authenticator App Code:
                </Heading>
            )
        },
    },
    ConfirmSignIn: {
        Header() {
            const { tokens } = useTheme()
            return (
                <Heading
                    padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
                    level={3}
                >
                    Enter MFA Code:
                </Heading>
            )
        },
    },
    ResetPassword: {
        Header() {
            const { tokens } = useTheme()
            return (
                <Heading
                    padding={`0 ${tokens.space.medium} 0 ${tokens.space.medium}`}
                    level={3}
                    textAlign="center"
                >
                    Reset Your Password
                </Heading>
            )
        },
    },
    ConfirmResetPassword: {
        Header() {
            const { tokens } = useTheme()
            return (
                <Heading
                    padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
                    level={3}
                >
                    Let&apos;s reset your password!
                </Heading>
            )
        },
    },
}
